module.exports = __webpack_public_path__ + "static/media/loginIcon.5eeb733d.svg";